import * as React from "react"
import { useMutation } from "react-query"
import { Box, Heading, Flex, FormLabel, Switch, Text } from "@chakra-ui/react"

import { fetcher } from "../lib/fetcher"
import { useToast } from "../lib/hooks/useToast"
import { OrgPrefsResponse } from "../components/SettingsTab"
import { OrgEntity } from "../lib/types/org"

interface Props {
  organization: OrgEntity
  allowedEmailAlertTypes: string[]
}

export const NotificationSettings: React.FC<Props> = (props) => {
  const toast = useToast()

  const { mutateAsync: update } = useMutation<
    OrgPrefsResponse,
    unknown,
    { allowed_email_alert_types: (string | undefined)[] }
  >((data) =>
    fetcher(`organizations/${props.organization.uuid}/preference/`, {
      body: JSON.stringify(data),
      method: "PATCH",
    }),
  )

  const handleSwitch = async () => {
    try {
      const type = props.allowedEmailAlertTypes.includes("bicycle.ride_outside")
        ? []
        : ["bicycle.ride_outside"]
      const values = { allowed_email_alert_types: type }
      const res = await update(values)
      if (!res?.uuid) {
        toast({ description: "Error updating notification prefences", status: "error" })
      }
    } catch {
      toast({ title: "Network error", description: "Please check your internet connection", status: "error" })
    }
  }

  return (
    <>
      <Heading size="md" as="h4" color="gray.700">
        Notifications
      </Heading>
      <Text fontSize="0.8rem" color="gray.500">
        Which alerts would you like to receive?
      </Text>
      <Box border="1px solid" borderColor="gray.100" p={4} mb={4} mt={4} borderRadius="lg">
        <Text fontWeight="bold" color="gray.700">
          Out of service area
        </Text>
        <Text fontSize="0.8rem" color="gray.600" mb={3}>
          Fleet operators notified via:
        </Text>
        <Flex align="center">
          <FormLabel htmlFor="service-area-email" mr={2} mb={0} color="gray.600" fontSize="0.9rem">
            Email
          </FormLabel>
          <Switch
            id="service-area-email"
            defaultChecked={props.allowedEmailAlertTypes.includes("bicycle.ride_outside")}
            onChange={handleSwitch}
          />
        </Flex>
      </Box>
    </>
  )
}
